import { NgTemplateOutlet } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  contentChild,
  TemplateRef,
} from "@angular/core";
import { StandardNavLinkDropdownComponentContext } from "src/standard/standard-nav-link-dropdown/standard-nav-link-dropdown.component";

export type StandardNavTopActionsContext =
  StandardNavLinkDropdownComponentContext;

@Component({
  standalone: true,
  selector: "standard-nav-top",
  templateUrl: "./standard-nav-top.component.html",
  host: {
    class: "border-bottom",
  },
  styles: `
    nav {
      display: flex;
      max-width: 100vw;
      overflow-y: hidden;
      overflow-x: auto;
    }

    .top-nav-container {
      padding-inline-end: 12px;
    }

    ::ng-deep standard-nav-top .nav-item.nav-item-wider .nav-link {
      padding-inline-start: 12px;
      padding-inline-end: 12px;

      font-size: 16px;

      &:not(.active):hover {
        background-color: var(--bs-tertiary-bg);
      }
    }

    :host ::ng-deep {
      .nav-link {
        height: var(--bs-h-header);
        display: inline-flex;
        align-items: center;
        border-radius: 0;
      }

      .nav-link.child-active,
      .nav-link.active {
        background-color: var(--bs-primary) !important;
        color: white !important;
      }

      /* if a nav item is hidden by security, avoid an empty slot */
      .nav-item:empty {
        display: none;
      }

      /* use text-shadow since font-weight changing updates the width */

      /* make icons show bigger */
      standard-icon {
        & > svg {
          font-size: 22px;
        }
      }

      // Hide any icons that are present on start actions in the standard-nav-top
      // .start-actions-wrapper standard-icon {
      //   display: none;
      // }

      .rounded-button-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;

        standard-button,
        standard-nav-link,
        standard-nav-link-dropdown {
          button,
          a {
            display: flex;
            align-items: center;
            justify-content: center;

            border-radius: 100px;
            height: 33px;
            min-width: 33px;
            aspect-ratio: 1;

            background-color: var(--apt-btn-gray-bg);

            &:hover {
              background-color: var(--apt-btn-gray-bg-hover);
            }

            & > standard-line-clamp > span {
              display: flex !important;
              justify-content: center;
              align-items: center;
            }
          }
        }

        // For text-only things,
        // we style them similar to buttons
        // but without hover effects, etc.
        .rounded-button-label {
          display: flex;
          align-items: center;
          justify-content: center;

          border-radius: 100px;
          height: 33px;
          min-width: 33px;
          aspect-ratio: 1;
          padding-inline: 8px;

          background-color: var(--apt-btn-gray-bg);

          & > standard-line-clamp > span {
            display: flex;
          }
        }
      }
    }
  `,
  imports: [NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StandardNavTopComponent {
  readonly logoTemplate = contentChild<TemplateRef<never>>("logo");
  readonly startActionsTemplate =
    contentChild<TemplateRef<StandardNavTopActionsContext>>("startActions");
  readonly endActionsTemplate =
    contentChild<TemplateRef<StandardNavTopActionsContext>>("endActions");
}
